import styled from "styled-components";

export const AboutStyles = styled.section.attrs(props => ({
    id: props.id,
}))`
    padding: 8rem 0 0;
    min-height: 100vh;

    & .about__img {
        flex: 0 0 40%;
        max-width: 40%;

        @media screen and (max-width: 1000px) {
            flex: 0 0 100%;
            max-width: 100%;
            margin-bottom: 5rem;
        }

        & .img-box {
            padding: 1.5rem;
            border-radius: 5px;

            @media screen and (max-width: 1000px) {
                max-width: 60%;
                margin: auto;
            }

            & img {
                width: 100%;
                border: 10px solid transparent;
                border-radius: 5px;
            }
        }

        & .social__links {
            margin-top: 2rem;
            text-align: center;

            & a:hover #svgFm #path2{
                fill: var(--color-primary-dark);
            }

            & a {
                display: inline-block;
                width: 4rem;
                height: 4rem;
                font-size: 1.6rem;
                text-align: center;
                line-height: 4.5rem;
                color: var(--color-text);
                margin: 0 4px;
                border-radius: 50%;
                transition: all .3s ease;

                &::after {
                    border-radius: 50%;
                }

                &:hover {
                    color: var(--color-primary-dark);
                }

                & #svgFm {
                    display: inline-block;
                    width: 1.6rem;
                    height: 1.6rem;
                    object-fit: cover;
                    margin-top: 3px;

                    & #path0,
                    & #path1,
                    & #path3 {
                        fill: var(--color-background);
                    }

                    & #path2 {
                        fill: var(--color-text);
                    }
                }
            }
        }
    }

    & .about__info {
        flex: 0 0 60%;
        max-width: 60%;
        padding: 0 5rem;

        @media screen and (max-width: 1000px) {
            flex: 0 0 100%;
            max-width: 100%;
        }

        & span {
            font-weight: 600;
        }

        & p {
            font-size: 2.2rem;
            line-height: 40px;
            margin-bottom: 1.5rem;
            color: var(--color-text);

        }

        & .btn-link {
            margin: 3rem 4rem 0 0;
        }

        & .btn-link:not(:last-child) {
            margin-right: 4rem;
        }
    }
`;